// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2Lwcb","title":"Header_title__DvqGP","side":"Header_side__1CIwo"};